import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Martini } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDetail(detail) {
  if (detail == null) return "Something went wrong — try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(", ");
  return "Something went wrong — try again.";
}

export default function OwnerLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      toast.success("Welcome back!");
      onLogin(data);
    } catch (err) {
      toast.error(formatDetail(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="owner-login" className="grain flex min-h-screen items-center justify-center bg-espresso-deep px-5 py-16">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-cream/15 bg-espresso p-8 text-cream sm:p-10"
      >
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-gold text-espresso">
          <Martini className="h-5 w-5" />
        </span>
        <h1 className="mt-6 text-center font-display text-3xl sm:text-4xl">Owner's desk</h1>
        <p className="mt-2 text-center text-sm text-cream/60">
          Sign in to manage bookings and availability.
        </p>

        <label className="mt-8 block text-[11px] font-bold uppercase tracking-[0.2em] text-cream/50">
          Email
        </label>
        <input
          data-testid="owner-login-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-2 w-full rounded-xl border border-cream/20 bg-white/[0.04] px-4 py-3 text-sm text-cream outline-none transition-colors focus:border-gold"
          placeholder="you@shakensociety.com"
        />

        <label className="mt-4 block text-[11px] font-bold uppercase tracking-[0.2em] text-cream/50">
          Password
        </label>
        <input
          data-testid="owner-login-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 w-full rounded-xl border border-cream/20 bg-white/[0.04] px-4 py-3 text-sm text-cream outline-none transition-colors focus:border-gold"
          placeholder="••••••••••"
        />

        <button
          data-testid="owner-login-submit"
          disabled={busy}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gold px-8 py-3.5 text-sm font-semibold uppercase tracking-[0.18em] text-espresso transition-all duration-300 hover:bg-cream disabled:opacity-60"
        >
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Sign in
        </button>
      </form>
    </section>
  );
}